<template>
  <select-rates
    :bid-id="bidId"
    @cancel="cancel"
    @hide="hide"
    @submit="hide"
  />
</template>

<script>
  import selectRates from './SelectFinalAgreementRates.vue'

  export default {
    name: 'RbvHotelRfpSelectRatesDialog',
    components: { selectRates },
    props: { 'bidId': {
        required: true,
        type: String
      } },
    methods: {
      cancel ( reason ) { this.$emit('cancel', reason) },
      hide ( reason ) { this.$emit('hide', reason) }
    }
  }
</script>
